const quizRuleLocalization = {
  ko: {
    quiz: {
      title: "라이브 퀴즈",

      // UI Elements
      buzzerMode: "부저 모드",
      oxMode: "OX 모드",
      answerMode: "답변 모드",
      answer_inputMode: "답변 모드",
      enterQuestion: "질문을 입력하세요",
      start: "시작",
      stop: "중지",
      continue: "이어하기",
      reset: "초기화",
      revealResponses: "결과보기",
      waitingForHost: "호스트가 시작하길 기다리는 중...",
      currentMode: "현재 모드",
      submitted: "제출 완료",
      waitingForOthers: "다른 플레이어를 기다리는 중...",
      responseSubmitted: "응답이 제출되었습니다",
      buzzer: "부저",
      buzzerOrder: "부저 누른 순서",
      enterAnswer: "답변을 입력하세요",
      submit: "제출",
      responses: "응답 목록",
      hostQuestionPlaceholder: "질문을 입력하고 시작하세요",
      playerWaitingQuestion: "호스트의 질문을 기다리는 중...",
      waitingForResponses: "응답을 기다리는 중...",
      noResponsesYet: "아직 응답이 없습니다",

      // Rules
      rules: {
        overview: "개요",

        hostRole: "호스트 역할",
        hostRoleDesc: "퀴즈 모드 선택, 질문 작성, 게임 진행 제어",
        playerRole: "플레이어 역할",
        playerRoleDesc: "각 모드에 맞는 방식으로 응답 제출",
        gameFlow: "게임 흐름",
        gameFlowDesc: "호스트가 질문 → 참가자 응답 → 결과 공개",

        modes: "게임 모드",

        buzzerMode: "부저 모드",
        buzzerModeDesc: "부저를 누른 순서대로 우선권을 부여해보세요!",

        oxMode: "OX 모드",
        oxModeDesc: "OX퀴즈, 투표 등 다양하게 활용해보세요",

        answerMode: "답변 모드",
        answerModeDesc: "참가자들이 직접 답변을 입력할 수 있습니다",

        howToPlay: "게임 진행 방법",
        step1: "호스트가 원하는 퀴즈 모드를 선택합니다",
        step2: "질문을 입력하고 시작 버튼을 누릅니다",
        step3: "플레이어들이 모드에 따라 응답합니다",
        step4:
          "중지 버튼을 누르면 유저들의 응답 받기를 중단하고 다음 옵션을 선택할 수 있습니다:",
        step4Option1: "- 이어하기: 유저들의 응답을 다시 받을 수 있습니다",
        step4Option2: "- 결과보기: 현재까지의 응답 결과를 확인합니다",
        step4Option3: "- 초기화: 질문과 응답을 모두 초기화합니다",

        tips: "활용 팁",
        tip1: "프로젝터나 스크린화면이 있다면 관전용 플레이어로 접속하여 화면을 띄우세요.",
        tip2: "호스트는 모바일이나 별도 화면(듀얼모니터)에서 문제를 출제하세요.",
        tip3: "스크린에 결과를 공유하며 퀴즈를 진행할 수 있습니다.",
      },
    },
  },
  en: {
    quiz: {
      title: "Live Quiz",

      // UI Elements
      buzzerMode: "Buzzer Mode",
      oxMode: "O/X Mode",
      answerMode: "Answer Mode",
      answer_inputMode: "Answer Mode",
      enterQuestion: "Enter a question",
      start: "Start",
      stop: "Stop",
      continue: "Continue",
      reset: "Reset",
      revealResponses: "Reveal",
      waitingForHost: "Waiting for host to start...",
      currentMode: "Current Mode",
      submitted: "Submitted",
      waitingForOthers: "Waiting for others...",
      responseSubmitted: "Response submitted",
      buzzer: "BUZZER",
      buzzerOrder: "Buzzer Order",
      enterAnswer: "Enter your answer",
      submit: "Submit",
      responses: "Responses",
      hostQuestionPlaceholder: "Enter a question and start",
      playerWaitingQuestion: "Waiting for host's question...",
      waitingForResponses: "Waiting for responses...",
      noResponsesYet: "No responses yet",

      // Rules
      rules: {
        overview: "Overview",

        hostRole: "Host Role",
        hostRoleDesc: "Select quiz mode, create questions, control game flow",
        playerRole: "Player Role",
        playerRoleDesc:
          "Submit responses in the appropriate format for each mode",
        gameFlow: "Game Flow",
        gameFlowDesc: "Host asks question → Players respond → Results revealed",

        modes: "Game Modes",

        buzzerMode: "1. Buzzer Mode",
        buzzerModeDesc: "Give priority based on buzzer order!",

        oxMode: "2. O/X Mode",
        oxModeDesc: "Use for OX quiz, voting, and more",

        answerMode: "3. Answer Mode",
        answerModeDesc: "Participants can submit their own answers",

        howToPlay: "How to Play",
        step1: "Host selects the desired quiz mode",
        step2: "Enter a question and press start",
        step3: "Players respond according to the mode",
        step4:
          "Press stop to stop accepting user responses and access these options:",
        step4Option1: "- Continue: Resume accepting user responses",
        step4Option2: "- Reveal: View the current response results",
        step4Option3: "- Reset: Clear both questions and responses",

        tips: "Usage Tips",
        tip1: "If you have a projector or screen, connect as a spectator player to display the screen.",
        tip2: "Host should create questions on mobile or a separate screen (dual monitor).",
        tip3: "You can conduct quizzes by sharing results on the screen.",
      },
    },
  },
};

export default quizRuleLocalization;
